/**
 * .
 * Created by jlado on 8/2/18.
 */
export class MailTemplateProperty {

    code: string;
    tag: string;
    description: string;

    constructor(other ?: MailTemplateProperty) {
        if (other) {
            this.code = other.code;
            this.tag = other.tag;
            this.description = other.description;
        }
    }

    toString() {
        return this.description;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/mailTemplateProperty.ts
 **/